import {React, useEffect, useState, useRef} from 'react';
import '../App.css';
import './tree_service_parrish.css';
import './tree_service_sarasota.css';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import SlideInDiv from './slider.js'
import SlideInDivLeft from './slider2.js'
import { GiWillowTree } from "react-icons/gi";
import UserModal from './UserModal.js';
import useHorizontalScroll from './useHorizontalScroll.js';
import { useScrollBehavior } from './useScrollBehavior.js';
//import Image1 from '../images/image1.jpg';
//import Image4 from '../images/image4.jpg';
//import Image5 from '../images/image5.jpg';
//import Image6 from '../images/image6.jpg';
//import Image7 from '../images/image7.jpg';
//import Image9 from '../images/image9.jpg';
//import Image10 from '../images/image10.jpg';
//import Image12 from '../images/image12.jpeg';
//import Image44 from '../images/image44.jpg';
//import Image45 from '../images/image45.jpg';
//import Image48 from '../images/image48.jpg';
//import Image52 from '../images/image52.jpg';
//import { TbShieldCheckFilled } from "react-icons/tb";
import { GiPalmTree } from "react-icons/gi";
//import { GiFruitTree } from "react-icons/gi";
//import { GiBirchTrees } from "react-icons/gi";
//import ExpandedImage from './ExpandedImage.js';
//import Collapsible from "./Collapsible";
//import Quest_video from '../images/SamsShort2.mp4';
import Mats from './mats.js'
import Testimonials from './testimonials.js'
import Gallery from './gallery.js'
import Faqs from './faqs.js'
import GoogleMapSection from './GoogleMap.js'
import Footer from './footer4.js'


const Services_Parrish = () => {

    useScrollBehavior();

      const [isVisibleLinks3, setIsVisibleLinks3] = useState(false);
      const [isVisibleText3, setIsVisibleText3] = useState(false);
      const { scrollRef, scrollLeft, scrollRight } = useHorizontalScroll();
      const [isVisibleImage2, setIsVisibleImage2] = useState(false);
      const [expandedImage2, setExpandedImage2] = useState(null);
      const imageRef2 = useRef(null);
      const linksRef3 = useRef(null);
      const textRef3 = useRef(null);
      const [count, setCount] = useState(0);
      const [percentage, setPercentage] = useState(0);
      const [experience, setExperience] = useState(0); 
      const ref = useRef(null);
      const ref2 = useRef(null);
      const ref3 = useRef(null);
      const stickyRef2 = useRef(null);
      const overlayRef2 = useRef(null);
      const [isModalOpen, setIsModalOpen] = useState(false);
      const openModal = () => setIsModalOpen(true);
      const closeModal = () => setIsModalOpen(false);

      const handleScroll4 = () => {
            if (linksRef3.current) {
              const linksRect3 = linksRef3.current.getBoundingClientRect();
              const triggerOffsetLinks3 = 100;
              const triggerPointLinks3 = window.innerHeight - triggerOffsetLinks3;
              const isAboveTriggerPointLinks3 = linksRect3.top < triggerPointLinks3;
              setIsVisibleLinks3(isAboveTriggerPointLinks3);
            }
      
            if (textRef3.current) {
                  const textRect3 = textRef3.current.getBoundingClientRect();
                  const triggerOffsetText3 = 300; // Adjust this value for different trigger points
                  const triggerPointText3 = window.innerHeight - triggerOffsetText3;
                  const isAboveTriggerPointText3 = textRect3.top < triggerPointText3;
                  setIsVisibleText3(isAboveTriggerPointText3);
              }

              if (imageRef2.current) {
                const imageRect2 = imageRef2.current.getBoundingClientRect();
                const triggerOffsetImage2 = 130; // Adjust this value for different trigger points
                const triggerPointImage2 = window.innerHeight - triggerOffsetImage2;
                const isAboveTriggerPointImage2 = imageRect2.top < triggerPointImage2;
                setIsVisibleImage2(isAboveTriggerPointImage2);
              }

        };
      
        useEffect(() => {
            window.addEventListener('scroll', handleScroll4);
            handleScroll4(); // Check visibility on initial render
            return () => {
              window.removeEventListener('scroll', handleScroll4);
            };
        }, []);

            
            useEffect(() => {
                  const hash = window.location.hash.substring(1);
                  if (hash) {
                    const targetElement = document.getElementById(hash);
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
              }, []);

             
    return (
        <>
        <Helmet>
            <title>Clearwater Service | Sam's Tree Service</title>
            <meta name="description" content="Professional tree trimming services in Parrish FL. Enhance the health and appearance of your trees with expert trimming and pruning." />
            <link rel="canonical" href="https://samstreeservice.com/tree_service_parrish" />
        </Helmet>

        <div id='main_serviceDiv_location_Sarasota'>
            <div className="background-imageservice"></div>
            <div className="module_service_location_Sarasota" id="module_service1_location_Sarasota">
            <div id='service_div1_location_Sarasota'>
                <div id='cover_service_div1_location_Sarasota'>
                <div id='service_title_location_Sarasota'>
                            <h1>Serving Parrish</h1>
                    </div>
                </div>
                </div>	
            </div>
            <div className="module_service_location_Sarasota" id="module_service2_trimming_location_Sarasota16">
                    <div id='service_div3_location_Sarasota1'>
                          <div id='slideCon3_location_Sarasota1'>
                            <SlideInDiv>
                                <div id='slideInDive3_5_location_Clearwater'></div>	
                            </SlideInDiv>
                                <div id='container_Slide3_location_Sarasota'>
                            <SlideInDivLeft>
                                <div id='slideInDive2_3_location_Clearwater'></div>
                            </SlideInDivLeft>
                            <SlideInDivLeft>
                                <div id='slideInDive3_3_location_Clearwater'></div>
                            </SlideInDivLeft>	
                          </div>
                                        
                        </div>
                        <div id="service_buttons_container">
                            <Link to="/tree_trimming" style={{ textDecoration: 'none', color: 'inherit'}}><div className="service_buttons" id="Serv_but1">Tree Trimming</div></Link>
                            <Link to="/tree_removal" style={{ textDecoration: 'none', color: 'inherit'}}><div className="service_buttons" id="Serv_but2">Tree Removal</div></Link>
                            <Link to="/stump_removal" style={{ textDecoration: 'none', color: 'inherit'}}><div className="service_buttons" id="Serv_but3">Stump Removal</div></Link>
                            <Link to="/debris_hauling" style={{ textDecoration: 'none', color: 'inherit'}}><div className="service_buttons" id="Serv_but4">Debris Hauling</div></Link>
                        </div>
                        <div id='trimming_div4_location_Sarasota1' ref={textRef3} className={`text_div_Link3_location_Sarasota ${isVisibleLinks3  ? 'visible' : ''}`}>
                            <div id='icon_two_half0_3trimming_location_Sarasota'>
                                <div id='two_half_text0_1_3trimming_location_Sarasota'><h1> - - - - - -&nbsp;&nbsp;</h1>
                                </div><div id='icon_two_half_icon0_3trimming_location_Sarasota'><GiPalmTree /></div>
                                <div id='two_half_text0_2_3trimming_location_Sarasota'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
                            </div>
                            <h1>Professional Tree Service in Parrish Specializing In Dangerous Trees</h1>
                            <p><strong>At Sam's Tree Service</strong>, we handle the difficult and <strong>dangerous tree</strong> work 
                            that many companies avoid. If you're dealing with overgrown, unstable, or <strong>hazardous trees</strong> in <strong>Parrish</strong>, our 
                            experienced team has the equipment and training to manage them safely and efficiently. Whether branches are 
                            extending over your roof, blocking your driveway, threatening your carport, or growing too close to power lines, 
                            we provide precise trimming and strategic removals designed to protect your property and support healthier tree growth.</p>

                            <p>We regularly address high-risk and <strong>hazardous tree</strong> situations throughout <strong>Parrish</strong>, including 
                            storm-damaged limbs, leaning or compromised trees, internal decay, and heavy overgrowth common in Florida landscapes. 
                            From selective branch trimming to structural canopy reductions and controlled removals, each service is performed with 
                            careful consideration for <strong>Parrish's</strong> environment, rapid tree growth, and Florida's seasonal storms.</p>

                            <p><strong>Sam's Tree Service</strong> provides dependable, affordable, and professional tree care 
                            across <strong>Parrish</strong> and the surrounding <strong>Manatee County</strong> area. Our goal 
                            is to keep your property safe, maintain strong and healthy trees, and ensure your landscape remains 
                            well maintained throughout the year.

                            <div id='booklink_index3_location_Sarasota1' 
                                    onClick={(e) => {
                                    e.preventDefault(); // Prevent the default link action
                                    openModal();
                                    }}>Request An Appointment
                                </div>
                            </p>
                        </div>
                        {isModalOpen && <UserModal onClose={closeModal} />}
                        <UserModal isOpen={isModalOpen} onClose={closeModal} />
                </div>
                <div id='trimming_spacer_div3_location_Sarasota1'>
                  <div id='trimming_divlink_container3_location_Sarasota' ref={linksRef3}>
                    <div className={`trimming_spacer_div_Link3_location_Sarasota ${isVisibleLinks3  ? 'visible' : ''}`}
                         style={{ transitionDelay: '.3s' }}>
                        <h1><i class="bi bi-houses" style={{ fontSize: '2rem', color: 'green'}}></i>&nbsp;Residential Services</h1>
                        <p>We offer expert tree care for your home, including trimming, 
                           pruning, and safe tree removal. Our team ensures your trees 
                           remain healthy, enhancing your property's beauty and safety.</p>
                    </div>
                    <div className={`trimming_spacer_div_Link3_location_Sarasota ${isVisibleLinks3  ? 'visible' : ''}`}
                         style={{ transitionDelay: '.6s' }}>
                        <h1><i className="bi bi-buildings" style={{ fontSize: '2rem', color: 'green' }}></i>&nbsp;Commercial</h1>
                        <p>We provide safe, 
                           efficient, and budget-friendly tree removal services 
                           tailored to meet your commercial needs.</p>
                    </div>
                    <div className={`trimming_spacer_div_Link3_location_Sarasota ${isVisibleLinks3  ? 'visible' : ''}`}
                         style={{ transitionDelay: '.9s' }}>
                          <h1><i className="bi bi-exclamation-diamond"style={{ fontSize: '2rem', color: 'green' }} ></i>&nbsp;24/7 Emergency Services</h1>
                        <p>Trust us anytime, day or night, for fast and dependable tree care, 
                           safeguarding your property and loved ones when it matters most.
                        </p>
                    </div>
                    
                </div>
                </div>      
            </div>
            {/*} <div className="module_service_location_Sarasota" id="module_service2_5_location_Sarasota">
                    
                <Mats/>

            </div>*/}
            <div className="module_service_location_Sarasota" id="module_service3_location_Sarasota1">
                    
                <Testimonials/>

            </div>
            {/*<div className="module_service_location_Sarasota" id="module_service4_location_Sarasota">
                <Gallery/>
            </div>*/}
            <div className="module_service_location_Sarasota" id="module_service5_location_Sarasota">
                <Faqs/>
            </div>
            <div className="module_service_location_Sarasota" id="module_service6_location_Sarasota">
				<GoogleMapSection city="Parrish, FL" />
            </div>
            <Footer/>
        </div>
    </>
    );
};

export default Services_Parrish;
